var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-server-side',{attrs:{"id":"userMgmt","server-side-datasource":_vm.serverSideDatasource,"column-defs":_vm.columnDefs,"set-grid-api":_vm.setGridApi}})}
var staticRenderFns = []

export { render, staticRenderFns }